import logo from "../../Assets/logo192.png";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import styles from './BrowserNotSupported.module.scss';
const cx = classNames.bind(styles); 

const BrowserNotSupported = () => {
    const { t } = useTranslation();

    return <div className={cx('fiveheadSplashWrapper', 'notSupported')}>
    <div className={cx('content')}>
        <div className={cx('fivehead')}>
            <img className={cx('logo')} src={logo} alt="Azure Digital Twins" />
        </div>
        <div className={cx('text')}>
            <div className={cx('title')}>
                {t('browserNotSupportedText')}
            </div>
            {t('supportedBrowsers')}
        </div>
    </div>
</div>;
}

export default BrowserNotSupported;